export function exportReportToBackend(data: any) { // eslint-disable-line
  return {
    report_name: data.report_name,
    rows: data.rows,
  };
}

export function exportReportFromBackend(backendType: any) { // eslint-disable-line
  return backendType;
}
